import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from '../../theme/tokens';

export const useTableStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      borderRadius: 0,
    },
    table: {
      minWidth: '100%',
    },
    tableWrapper: {
      overflowX: 'auto',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    tableHead: {
      backgroundColor: colors.bgSurface,
    },
    cardList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      padding: theme.spacing(1.5),
    },
    mobileCard: {
      border: `1px solid ${colors.border}`,
      borderRadius: 10,
      padding: '12px 14px',
      background: colors.bgSurface,
    },
    mobileCardRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      padding: '5px 0',
      borderBottom: `1px solid ${colors.border}`,
      '&:last-child': { borderBottom: 'none' },
    },
    mobileCardLabel: {
      fontSize: 11,
      fontWeight: 700,
      color: colors.textFaint,
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
      flexShrink: 0,
    },
    mobileCardValue: {
      fontSize: 13,
      color: colors.textPrimary,
      textAlign: 'right',
      minWidth: 0,
      overflow: 'hidden',
    },
  }),
);
